module.exports = __webpack_public_path__ + "img/H-45-ER-550-BB.5e30b7a7.png";